module.exports = __webpack_public_path__ + "static/media/close_button.77d52299.svg";